import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "../common/Button";

const IntservTokenValidation = ({ modalShow, handleClose }) => {
    return (
        <Modal
            size="lg"
            show={modalShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="custom-dialog"
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    API Credentials Validated
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>This is a valid API credentials and can be used to access the florizel API's.</p>
            </Modal.Body>
            <Modal.Footer>
                <div className="action-wrap" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Button variant="primary" onClick={handleClose}>
                        OK
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default IntservTokenValidation;

